module.exports = __webpack_public_path__ + "images/178_4096.jpg";